import type { RouteObject } from 'react-router-dom';
import { Navigate } from 'react-router-dom';

import { paths } from '@app/constants';
import { lazyFeature } from '@app/utils/feature-flags';

const TrialsV2Page = lazyFeature(() => import('./index'), 'TrialsV2Page');
const TrialsV2TrialsTab = lazyFeature(() => import('./components/TrialsTab'), 'TrialsV2TrialsTab');
const TrialsV2CohortsTab = lazyFeature(
  () => import('./components/CohortsTab'),
  'TrialsV2CohortsTab',
);
const TrialsV2ProcessedCriteriaTab = lazyFeature(
  () => import('./components/ProcessedCriteriaTab'),
  'TrialsV2ProcessedCriteriaTab',
);

export const trialsV2Routes = (): RouteObject[] => [
  {
    path: paths.trials_v2.root,
    element: <TrialsV2Page />,
    children: [
      { index: true, element: <Navigate to={paths.trials_v2.trials} /> },
      { path: paths.trials_v2.trials, element: <TrialsV2TrialsTab /> },
      { path: paths.trials_v2.cohorts, element: <TrialsV2CohortsTab /> },
      { path: paths.trials_v2.processed_criteria, element: <TrialsV2ProcessedCriteriaTab /> },
    ],
  },
];
